<template>
  <div class="header container">
    <div class="col-xs-12">
      <router-link to='/'>
        <h2 class="logo">Вкусомер</h2>
      </router-link>
      <Switcher/>
    </div>
    <div v-if="person.id" class="person col-xs-6">
      
      <router-link :to="`/upload/`">
        <img class="person--upload" src="/static/icon-upload.svg"/>
      </router-link>
      <router-link class="person--avatar-wrap" :to="profileLink()">
        <img v-if="person.profile_photo" @click="updateUser(person.id)" class="person--photo" :src="person.profile_photo"/>
        <div v-else-if="person.first_name" @click="updateUser(person.id)" :style="`background: ${calcColor(person.compare_etalon)}`" class="person--avatar">{{ person.first_name[0] }}{{ person.last_name[0] }}</div>
      <router-link class="person--settings" v-if="personIsAdmin && fancyCounter > 0" :to="`/moderate/web/`">
        <span >{{ fancyCounter }}</span>
      </router-link>


      </router-link>
      <a href='/accounts/logout/?next=/'>
        <img class="person--exit" src="/static/exit.svg">
      </a>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';

import Navigation from '@/components/Navigation';
import Switcher from '@/components/Switcher';

import colorLibrary from '@/utils/colorLibrary';

export default {
  name: 'heady',
  components: {
    Navigation,
    Switcher,
  },

  computed: mapGetters({
    personIsAdmin: 'personIsAdmin',
    person: 'personCurrent',
    fancyCounter: 'fancyCounter',
    fancyList: 'fancyList',
    fancyInfo: 'fancyInfo',
    theme: 'theme',
  }),

  methods: {
    updateUser(userId) {
      this.$store.commit('SET_CATEGORY', 'all');
      if (this.person.id > 0) {
        this.$store.commit(types.CLEAR_PERSONS);
        setTimeout(() => {
          this.$store.dispatch('fetchPerson', userId);
        }, 200);
      }
    },
    calcColor(coeff) {
      return colorLibrary(coeff).top;
    },
    profileLink() {
      return this.personIsAdmin ? '/refs/web/' : `/accounts/${this.person.id}/`;
    },
  },
};
</script>

<style>
@keyframes header{
  from,20%{
    transform: translate3d(0,-20px,0);
    opacity: 0;
  }
  to{
    transform: translate3d(0,0,0);
    opacity: 1;
  }
}

.header{
  animation: header .5s ease-in-out;
  position: relative;
  
  padding: 10px 50px;
  z-index: 999;

  @media (max-width: $mediaIpad) {
    white-space: nowrap;
    padding: 10px;
  }

  .logo{
    text-decoration: none;
    margin-bottom: 12px;
    margin-left: -4px;
    font-family: Flai;
    border-bottom: 0;
    color: black;

    @media (min-width: $mediaIpad) {
      text-align: center;
      font-size: 260%;
    }

    a{
      color: black;
      border-bottom: 0;
    }

    &:hover{
      border-bottom: 0;
      color: black;
      a{
        color: black;
      }
    }
  }
  .person{
    position: absolute;
    text-align: right;
    max-width: 140px;
    right: 0;

    a{
      border-bottom: 0;
    }
    &--avatar,
    &--photo{
      border-radius: 50%;
      height: 35px;
      width: 35px;
      &:hover{
        transform: scale(1.1);
      }
    }

    .router-link-exact-active{
      .person--avatar{
        cursor: text;
        &:hover{
          transform: none;
        }
      }
    }

    &--avatar{
      text-align: center;
      line-height: 2.4;
      font-weight: 300;
      color: white;

      &-wrap{
        position: relative;
      }
    }


    &--exit{
      width: 18px;
      &:hover{
        opacity: .6;
      }
    }

    &--upload,
    &--avatar,
    &--photo,
    &--exit{
      transition: all .3s ease-in-out;
      display: inline-block;
      vertical-align: middle;
      margin: 18px 3px 0;
      cursor: pointer;
    }

    &--upload{
      margin-right: 18px;
      margin-top: 19px;
      width: 16px;
      &:hover{
        opacity: .6;
      }
    }

    &--settings{
      transition: all .3s ease-in-out;
      transform-origin: center center;
      text-align: center;
      border-radius: 50%;
      position: absolute;
      line-height: 2.1;
      background: red;
      cursor: pointer;
      font-size: 70%;
      color: white;
      height: 22px;
      width: 22px;
      right: -2px;
      top: -10px;
      &:hover{
        transform: scale(1.2);
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Heady.vue?d79a8070